

























import { defineComponent, ref, watch } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'
import SupportContactTiles from '@/components/feature/learn-and-support/technical-support/support-tiles/SupportContactTiles.vue'

// Store
import { useKnowledgeBaseStore } from '~/store/knowledge-base'

export default defineComponent({
  name: 'EmptySupportArticles',
  components: {
    SupportContactTiles,
  },
  setup() {
    const knowledgeBaseStore = useKnowledgeBaseStore()
    const { searchInput, results, ui } = storeToRefs(knowledgeBaseStore)
    const emptySearchInput = ref(searchInput.value)
    watch(results, () => {
      emptySearchInput.value = searchInput.value
    })

    return {
      emptySearchInput,
      ui,
    }
  },
})
